import { ImageStatic } from 'approot/shared/images/images';
import { StimulusImage } from './stimulus-search-item.style';
import Pagination from 'approot/shared/pagination/pagination';
import { FlexCentreAlign } from 'approot/shared/styles/flex.style';
import useDocumentPreview from 'approot/activity-builder/components/document/document-preview.hooks';

type Props = {
  fileKey: string | null;
};

const StimulusPagesPreview = ({ fileKey }: Props) => {
  const {
    currentImage,
    getPagePreviewIndex,
    getPrevPreviewImage,
    getNextPreviewImage,
    previewPageCount,
  } = useDocumentPreview({
    documentKey: fileKey || '',
    previewSize: 500,
  });

  return (
    <StimulusImage>
      <ImageStatic imageUrl={currentImage || ''} />
      {previewPageCount > 1 && (
        <FlexCentreAlign $marginBottom={8}>
          <Pagination
            isSmall
            currentPage={getPagePreviewIndex()}
            onPrevious={getPrevPreviewImage}
            onNext={getNextPreviewImage}
            totalPageCount={previewPageCount}
          />
        </FlexCentreAlign>
      )}
    </StimulusImage>
  );
};

export default StimulusPagesPreview;
